<template>
  <v-app>
    <v-navigation-drawer
      v-model="show_drawer"
      temporary
      fixed
      v-if="drawer_enabled"
    >
      <v-card id="nav_card" color="blue lighten-3">
        {{ this.$store.getters["user/auth_profile"].email }}
      </v-card>
      <v-divider></v-divider>
      <v-container>
        <v-list nav>
          <v-list-item link v-on:click="go_to_dashboard">
            <v-list-item-icon>
              <v-icon>home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-on:click="go_to_profile">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Your Profile</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-on:click="go_to_products">
            <v-list-item-icon>
              <v-icon>apps</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Your Products</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-on:click="go_to_settings">
            <v-list-item-icon>
              <v-icon>settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-on:click="logout">
            <v-list-item-icon>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-btn v-if="backArrow" icon v-on:click="go_back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-app-bar-nav-icon
        v-on:click="show_drawer = !show_drawer"
        v-if="drawer_enabled"
      ></v-app-bar-nav-icon>

      <v-img
        :src="require('@/logo.png')"
        max-height="40"
        max-width="40"
        contain
      >
      </v-img>

      <v-toolbar-title>
        Account
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",

  data() {
    return {
      drawer_enabled: false,
      show_drawer: false,
      backArrow: false
    };
  },
  mounted() {
    this.backArrow = this.$route.name !== "home";
    this.drawer_enabled = this.$route.name === "home";
  },
  watch: {
    $route: function() {
      this.backArrow = this.$route.name !== "home";
      this.drawer_enabled = this.$route.name === "home";
    }
  },
  methods: {
    ...mapActions("user", {
      signout: "logout"
    }),
    logout() {
      this.signout()
        .then(() => {
          this.$router.push("/signin");
        })
        .catch(() => {
          this.$router.push("/signin");
        });
    },
    go_back() {
      this.$router.back();
    },
    go_to_settings() {
      this.show_drawer = false;
      this.$router.push("/settings");
    },
    go_to_dashboard() {
      this.$router.push("/home");
    },
    go_to_profile() {
      this.$router.push("/profile");
    },
    go_to_products() {
      this.$router.push("/products");
    }
  }
};
</script>
<style scoped>
#nav_card {
  color: white;
  padding: 30px 8px 8px;
}
</style>
